import React, { useEffect, useState } from 'react'
import FullPageSlider from '../components/FullPageSlider/FullPageSlider'
import { useDispatch, useSelector } from 'react-redux'
import { getSendDesignProducts } from '../appState/slices/product/productSlice'
import { getColors } from '../appState/slices/color/colorSlice'
import { getWishlistProducts } from '../appState/slices/wishlist/wishlistSlice'
import Loader from '../components/loader/Loader'
import { HomeRevealFloating } from '../components'
import LaunchGate from '../components/LaunchGate/LaunchGate'
import LaunchModal from '../components/LaunchModal/LaunchModal'

const Home = () => {

  const loading = useSelector(
    state => state.product.isLoading
  )

  const dispatch = useDispatch()

  const [launchOpened, setLaunchOpened] = useState(false)

  const [showLaunchModal, setShowLaunchModal] = useState(false)


useEffect(() => {

  dispatch(getColors())
  dispatch(getSendDesignProducts())
  dispatch(getWishlistProducts())

  const alreadyOpened = localStorage.getItem(
    'purecarats_launch_opened'
  )

  if (alreadyOpened === 'true') {

    setLaunchOpened(true)

    // Always show launch price popup
    setShowLaunchModal(true)

  }

}, [dispatch])


  /*
   * This is called after the door-opening animation
   */
  const handleLaunchOpen = () => {

    setLaunchOpened(true)

    // Open price-drop popup
    setShowLaunchModal(true)

  }


  const closeLaunchModal = () => {

    setShowLaunchModal(false)

  }


  if (loading) {

    return (
      <div>
        <Loader />
      </div>
    )

  }


  return (

    <div>

      {/* Launch Gate */}
      {!launchOpened && (
        <LaunchGate
          onOpen={handleLaunchOpen}
        />
      )}


      {/* Actual Website */}
      <HomeRevealFloating />

      <FullPageSlider />


      {/* Launch Price Popup */}
      {/* {showLaunchModal && (
        <LaunchModal
          onClose={closeLaunchModal}
        />
      )} */}

    </div>

  )
}

export default Home